/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IMoeQuickViewContainerViewProps } from './moe-quick-view-container';

export default (props: IMoeQuickViewContainerViewProps) => {
    const { data } = props;
    const quickviewSlot = props.slots && props.slots.quickview && props.slots.quickview.length > 0 ? props.slots.quickview[0] : null;
    const recordId = data?.product?.result?.RecordId;
    return <>{quickviewSlot && recordId && renderQuickView(quickviewSlot, recordId)}</>;

    /**
     * Gets the react node for  product description.
     * @param  quickview - Quick view node.
     * @param  item - Product id to de displayed in quickview.
     * @returns The product quickview component.
     */
    function renderQuickView(quickview: React.ReactNode, item?: number): JSX.Element | undefined {
        if (quickview === null) {
            return undefined;
        }
        return React.cloneElement(quickview as React.ReactElement, { selectedProductId: item, selectedDimensions: null });
    }
};
